var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointerSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.17799 0 -4.95746e-06 7.178 -4.95746e-06 15.99C-0.058005 28.88 15.392 39.568 16 40C16 40 32.058 28.88 32 16C32 7.178 24.822 0 16 0ZM16 24C11.58 24 8 20.42 8 16C8 11.58 11.58 8 16 8C20.42 8 24 11.58 24 16C24 20.42 20.42 24 16 24Z",
    fill: "#DED2CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerSidebar);
export default __webpack_public_path__ + "static/media/pointer_sidebar.da05eaf0832c9d9f17a534b46063ce44.svg";
export { ForwardRef as ReactComponent };